import { Box, Button, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { icons } from "src/assets";
import { PrivateLoader } from "src/components/templates";
import Table from "src/components/UI/CustomUI/organisms/Table";
import { territoriesActions } from "src/ducks/actions";
import { getEmployee, getTerritories } from "src/ducks/selectors";
import { EMPLOYEE_ROLE_TYPE } from "src/helpers";
import AddTerritoryModal from "./AddTerritoryModal";
import headers from "./headers";
import { SelectInput } from "src/components/UI";
import { SelectInputOption } from "src/components/UI/CustomUI/atoms/SelectInput/types";
import { SearchParams } from "src/ducks/territories/types";

const Territories: FC = () => {
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const territories = useSelector(getTerritories)
    const [open, setOpen] = useState(false)
    const navigate = useNavigate()
    const currentUser = useSelector(getEmployee)
    const isSuperAdmin = currentUser.roles.find(role => role.roleType === EMPLOYEE_ROLE_TYPE.SUPER_ADMIN)
    const serviceableOption = [
        { key: 'all', label: 'All' },
        { key: 'serviceable', label: 'Serviceable' },
        { key: 'non-serviceable', label: 'Non Serviceable' }
    ] as SelectInputOption[]

    const [serviceable, setServiceable] = useState(serviceableOption[0])

    const docusignOption = [
        { key: 'all', label: 'All' },
        { key: 'enabled', label: 'Enabled' },
        { key: 'disabled', label: 'Disabled' }
    ] as SelectInputOption[]

    const [hasDocusign, setHasDocusign] = useState(docusignOption[0])

    const getParams = () => {
        const searchParams = {} as Partial<SearchParams>
        if (serviceable && serviceable?.key !== 'all') { searchParams.isServiceable = serviceable.key === 'serviceable' }
        if (hasDocusign && hasDocusign?.key !== 'all') { searchParams.hasDocusignContract = hasDocusign.key === 'enabled' }
        return searchParams
      }

    useEffect(() => {
        setIsLoading(true)
        dispatch(territoriesActions.fetchTerritories({ page: undefined, size: undefined, searchParams: getParams()} , (succ: boolean) => setIsLoading(false)))
    }, [dispatch, serviceable, hasDocusign])

    const handleNew = () => setOpen(true)

    const handleClickRow = (row: any, e: React.MouseEvent) => {
        navigate(`${row.id}`)
    }

    const handleServiceableChange = (newSelected: SelectInputOption) => {
        if (newSelected === null) {
          setServiceable(serviceableOption[0])
        } else {
          setServiceable(newSelected)
        }
      }

    const handleDocusignChange = (newSelected: SelectInputOption) => {
        if (newSelected === null) {
          setHasDocusign(docusignOption[0])
        } else {
          setHasDocusign(newSelected)
        }
      }

    return (
        <PrivateLoader loading={isLoading}>
            <Box mb={4}>
                <Box display="flex" justifyContent="space-between" alignItems="flex-end" mb={2}>
                    <Typography variant="h1" sx={{lineHeight: 1 }}>Territory Management</Typography>
                    <Box gap={2} display="flex" alignItems="flex-end">
                        <SelectInput
                            label='Serviceable:'
                            onChange={handleServiceableChange}
                            options={serviceableOption}
                            value={serviceable}
                            sx={{ maxWidth: '240px', minWidth: '156px', flex: '1' }}
                        />
                        <SelectInput
                            label='Docusign:'
                            onChange={handleDocusignChange}
                            options={docusignOption}
                            value={hasDocusign}
                            sx={{ maxWidth: '240px', minWidth: '156px', flex: '1' }}
                        />
                        <Button variant="contained" disabled={!isSuperAdmin} startIcon={<icons.Add />} onClick={handleNew}>New Territory</Button>
                    </Box>
                </Box>

                <Table headers={headers} hasPagination={false}>
                    {territories.map((territory) => ({
                        ...territory,
                        disabled: false,
                        action: handleClickRow
                    }))}
                </Table>
            </Box>
            <AddTerritoryModal open={open} setOpen={setOpen} />
        </PrivateLoader>
    )
};

export default Territories;